import z from 'zod';

import { socialApiClient } from '@/shared/api-client/social-api-client';

import {
  searchConditionsSchema,
  searchModeMessageResponseSchema,
  type SearchModeMessageResponse,
} from '../schema';

export const createSearchModeMessageRequestSchema = z.object({
  message: z.string().min(1),
  search_conditions: searchConditionsSchema,
});

export type CreateSearchModeMessageRequest = z.infer<typeof createSearchModeMessageRequestSchema>;

export async function createSearchModeMessage(
  discoverySessionId: string,
  request: CreateSearchModeMessageRequest,
  signal?: AbortSignal,
): Promise<SearchModeMessageResponse> {
  const parsedRequest = createSearchModeMessageRequestSchema.parse(request);
  const response = await socialApiClient.post(
    `discovery-sessions/${discoverySessionId}/search-mode-message`,
    {
      json: parsedRequest,
      signal,
    },
  );

  return searchModeMessageResponseSchema.parse(await response.json());
}
